
<div id="r-card" class="result-card" *ngIf="flightOption">
    <div class="result-card-header" *ngIf="showHeader">
        <div class="request-sent-pill" *ngIf="chipText">{{chipText}}</div>
        <div class="creator-name">
            {{privateName}}
        </div>
        <div class="detail-row">
            <div class="detail-item review" [ngClass]="{'active' : isReviewed}">
                <div class="icon">
                    <app-svg-loader height="12px" url="assets/svg/star-solid.svg"></app-svg-loader>
                </div>
                <div class="value" *ngIf="isReviewed">{{reviewStat}}</div>
                <div class="value" *ngIf="!isReviewed">No Reviews</div>
            </div>
             <div class="detail-item">
                <div class="icon" style="transform: translateY(1px);">
                    <app-svg-loader height="12px" url="assets/svg/jet-solid.svg"></app-svg-loader>
                </div>
                <div class="value text-capitalize-case">{{flightOption?.membershipOrganization}}</div>
            </div>
        </div>
    </div>
    <div class="result-card-body">

        <div class="location-row">
            <div class="location">
                {{l(flightOption.departureLocationName)}}
                <span class="airport-code">({{flightOption.departureAirportCode}})</span>
            </div>
            <div class="arrow">
                <app-svg-loader height="14px" url="assets/svg/chev-bold-right.svg"></app-svg-loader>
            </div>
            <div class="location" *ngIf="flightOption.arrivalLocationName">
                {{l(flightOption.arrivalLocationName)}}
                <span class="airport-code">({{flightOption.arrivalAirportCode}})</span>
            </div>
            <div class="location" *ngIf="!flightOption.arrivalLocationName">
                Any {{flightOption.arrivalGeneralType}}
                <ng-container *ngIf="flightOption.arrivalGeneralState || flightOption.arrivalGeneralCountry">
                    in
                    <span *ngIf="flightOption.arrivalGeneralState">{{flightOption.arrivalGeneralState}}</span>
                    <span *ngIf="flightOption.arrivalGeneralState && flightOption.arrivalGeneralCountry">, </span>
                    <span *ngIf="flightOption.arrivalGeneralCountry">{{flightOption.arrivalGeneralCountry}}</span>
                </ng-container>
            </div>
        </div>

        <div class="detail-row">
            <div class="detail">
                <div class="icon">
                    <app-svg-loader height="14px" url="assets/svg/cal-solid.svg"></app-svg-loader>
                </div>
                <div class="value" *ngIf="flightOption.departureDateExact; else dateRangeTemplate">{{d(flightOption.departureDateExact)}}</div>
                <ng-template #dateRangeTemplate>
                    <div class="value">
                        {{d(flightOption.departureDateRangeStart)}} - {{d(flightOption.departureDateRangeEnd)}}
                    </div>
                </ng-template>
            </div>
            <div class="detail">
                <div class="icon">
                    <app-svg-loader height="14px" url="assets/svg/clock-solid.svg"></app-svg-loader>
                </div>
                <div class="value" *ngIf="flightOption.departureTimeExact; else timeRangeTemplate">{{t(flightOption.departureTimeExact)}} {{timezone}}</div>
                <ng-template #timeRangeTemplate>
                    <div class="value">
                        {{t(flightOption.departureTimeRangeStart)}} - {{t(flightOption.departureTimeRangeEnd)}} - {{timezone}}
                    </div>
                </ng-template>
            </div>
        </div>

        <div class="detail-row" *ngIf="showSeats">
            <div class="detail">
                <div class="icon">
                    <app-svg-loader height="14px" url="assets/svg/seat-cube.svg"></app-svg-loader>
                </div>
                <div class="value" *ngIf="flightOption.seatsNeeded; else seatsOfferedTemplate">{{flightOption.seatsNeeded}} Seats Needed</div>
                <ng-template #seatsOfferedTemplate>
                    <div class="value">
                        {{flightOption.seatsOffered}} Seats Available
                    </div>
                </ng-template>
            </div>
        </div>

    </div>
</div>
